import React, { useEffect } from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import useWorkspaceId from '../../hooks/useWorkspaceId'
import urlHelper from '../../helpers/urlHelper'

const SSOPageRawSettings = () => {
  const workspaceId = useWorkspaceId()
  const history = useHistory()

  useEffect(() => {
    // if workspaceId is not found, redirect to sign-in page with current URL
    if (!workspaceId) {
      return history.push('/sign-in?redirect=' + encodeURIComponent(window.location.href))
    }

    const settingURL = urlHelper.getAccountPageUrl(workspaceId)
    window.location.href = settingURL
  }, [])

  return <>System is redirecting you to setting page...</>
}

export const SSOSettingsPage = withRouter(SSOPageRawSettings)
